export const ANALYTICS_EVENT = {
  MfaScreenView: "mfa_screen_view",
  MfaSendCode: "mfa_send_code",
  PortalLogin: "portal_login",
} as const;

